import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AbstractComponent } from '../../abstract.component';
import { SolIconComponent } from '../../core/sol-icon/sol-icon.component';
import { SolViewComponent } from '../../view/sol-view/sol-view.component';
import { SolText } from '../../../models/core/sol-text';
import { SolType } from '../../../models/core/sol-type';
import { SolTable } from '../../../models/overview/sol-table';
import { TranslatePipe } from '../../../pipes/translate.pipe';
import { SolReportTableState } from './sol-report-table.state';

@Component({
  selector: 'sol-report-table',
  standalone: true,
  imports: [SolViewComponent, SolIconComponent, TranslatePipe, DatePipe],
  templateUrl: './sol-report-table.component.html',
})
export class SolReportTableComponent<S = unknown> extends AbstractComponent<SolReportTableState<S>> {
  protected readonly SolType = SolType;

  protected readonly table$ = this.compute(s => s.table);
  protected readonly summary$ = this.compute(s => s.summary);
  protected readonly tableStyle$ = this.compute(s => s.tableStyle);

  public constructor() {
    super(SolReportTableState.of<S>());
  }

  @Input() public set table(value: SolTable<S> | undefined) {
    this.update(s => s.withTable(value));
  }

  @Input() public set summary(value: SolText | undefined) {
    this.update(s => s.withSummary(value));
  }
}
